import { AfterViewInit, Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-redesign-metrics',
  templateUrl: './redesign-metrics.component.html',
})
export class RedesignMetricsComponent implements AfterViewInit {
  constructor(private router: Router) {} 
   ngAfterViewInit(): void {
    window.open('https://spotfire-hou.chevron.com/spotfire/wp/ViewAnalysis.aspx?file=/ETC/TC/CemSYS/Analysis%20Files/RedesignMetrics','_blank', 'noopener');
    this.router.navigate(['/home']);
  }
}
